export default __webpack_public_path__ + "f3d8f19c4942ab94b208366b0f9c74d7.svg";